import { cx } from "@shared/components/untitledui/util/cx"
import styles from "./LessonDropNotice.module.css"

/**
 * A warm veil over the slot saying what releasing here will do, before it happens.
 * pointer-events-none keeps the native dragover/drop reaching the slot below.
 */
export default function LessonDropNotice({
  bumpsExistingLesson,
}: {
  bumpsExistingLesson: boolean
}) {
  return (
    <div
      data-test="lesson drop message"
      className={cx(
        "pointer-events-none absolute inset-0 z-10 flex flex-col items-center justify-center gap-1 rounded-md px-3 text-center",
        styles.notice,
      )}
    >
      <div className="text-[0.9375rem] leading-tight font-bold text-gray-900">Drop here</div>
      {bumpsExistingLesson && (
        <div className="text-xs leading-tight text-gray-600">
          And the lesson that’s here will bump forward →
        </div>
      )}
    </div>
  )
}
